import '.l{display:flex;}.ssr-plugin'
import '.az{align-items:stretch;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.d6{background:var(--palette-white);}.ssr-plugin'
import '.cq{flex-grow:1;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.br{max-width:77.5rem;}.ssr-plugin'
import '.ef{justify-content:stretch;}.ssr-plugin'
import '.eg{position:sticky;}.ssr-plugin'
import '.cs{top:0;}.ssr-plugin'
import '.eh{z-index:10;}.ssr-plugin'
import '.ei{padding-block:1rem;}.ssr-plugin'
import '.ej{height:3rem;}.ssr-plugin'
import '.an{justify-content:space-between;}.ssr-plugin'
import '.a7{flex-wrap:wrap;}.ssr-plugin'
import '.ek{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bp{margin-top:2rem;}.ssr-plugin'
import '.el{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="l az a1 m d6"
      >
        <div className="cq l aa a1 m"
        >
          <div className="br l m ef eg cs eh d6"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="ei ej l an aa a7"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ek l m az bp el br"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
